<script>
export default {
    props: {
        treatment: Object
    },
    computed: {
        total() {
            if (this.treatment) {
                return (this.treatment.price * this.treatment.number)
            }
        }
    }
}
</script>

<template>
    <div class="hosityheader">
    <ul class="ullist">
    <li>购买日期</li>
    <li>购买人</li>
    <li>购买个数</li>
    <li>支付金额</li>
    </ul>
    </div>
</template>

<style lang="scss" scoped>
@import '@/css/acountInfoContent.scss';
.hosityheader{
    width:100%;
    height:54px;
    background: #FAFAFA;
    border-radius: 3px 3px 0px 0px;
    margin:35px 0 0 0;
}
.ullist{
    width:100%;
    display:flex;
}
.ullist li{
    flex:1;
    list-style:none;
    float:left;
    text-align:center;
    height:50px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 50px;
}
.ullist li:nth-child(1){
    text-align:left;
    text-indent:25px;
}
.ullist li:nth-child(4){
    text-align:left;
    text-indent:64px;
}

</style>





// WEBPACK FOOTER //
// src/components/acount/PurchaseHistory.vue